import { render, staticRenderFns } from "./videobox.vue?vue&type=template&id=0dd197f6&scoped=true&"
import script from "./videobox.vue?vue&type=script&lang=js&"
export * from "./videobox.vue?vue&type=script&lang=js&"
import style0 from "./videobox.vue?vue&type=style&index=0&id=0dd197f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd197f6",
  null
  
)

export default component.exports